import * as React from 'react';

function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
const IconHeartEmpty = (props)=>/*#__PURE__*/ React.createElement("svg", _object_spread({
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 18 15",
        width: "1em",
        height: "1em"
    }, props), /*#__PURE__*/ React.createElement("path", {
        d: "M13.071 0.750135V0.750159L13.0771 0.75012C13.6404 0.746525 14.1979 0.850826 14.7155 1.0558C15.2323 1.26049 15.6974 1.56076 16.084 1.93658C16.8467 2.68738 17.2603 3.68243 17.2498 4.70604C17.2393 5.73029 16.8049 6.71862 16.0256 7.45594L16.0256 7.45601L15.522 7.93258L15.5218 7.9328L9.00265 14.1074L1.97437 7.45861C1.97435 7.45859 1.97434 7.45858 1.97433 7.45857C1.19506 6.72125 0.760672 5.73294 0.750194 4.7087C0.739723 3.68507 1.1533 2.69 1.91604 1.93919C2.30342 1.5621 2.76975 1.26088 3.28807 1.05571C3.80701 0.850305 4.36593 0.746024 4.93073 0.750116V0.750146L4.93743 0.750135C6.12165 0.748143 7.25067 1.19111 8.07871 1.96999C8.07897 1.97023 8.07922 1.97047 8.07948 1.97071L8.4887 2.35799L9.00422 2.84586L9.51974 2.35799L9.92896 1.97071C9.9292 1.97049 9.92944 1.97026 9.92967 1.97004C10.7577 1.19113 11.8868 0.748143 13.071 0.750135Z",
        stroke: "#000",
        strokeWidth: 1.5
    }));

export { IconHeartEmpty };
